export default "__VITE_ASSET__DcY_hVJ1__"